import Lottie from 'lottie-react';
import React from 'react';

type Props = {
  animationData: Object;
  loop: boolean;
  style: React.CSSProperties;
};

const LottieAnimation: React.FC<React.PropsWithChildren<Props>> = ({
  animationData,
  loop,
  style,
}) => {
  return <Lottie animationData={animationData} loop={loop} style={style} />;
};

export default LottieAnimation;
